module.exports = __webpack_public_path__ + "img/dataquality-dashboard-homeicon.0174c6b2.png";